import React from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import './ManagementBoard.css'; // Assuming we'll create this for styling
import { useTranslation } from 'react-i18next';

const ManagementBoard = () => {
  const { t } = useTranslation();

  const boardMembers = [
    {
      id: 1,
      name: 'Prof. Dr. Hatice Mergen',
      email: 'mergen@hacettepe.edu.tr',
      title: t('dean.title'),
      image: 'https://avesis.hacettepe.edu.tr/user/image/5582',
    },
    {
      id: 2,
      name: 'Prof. Dr. Canan Köroğlu',
      email: 'ckoroglu@hacettepe.edu.tr',
      title: t('faculty_board.professor_member'),
      image: 'https://avesis.hacettepe.edu.tr/user/image/6842',
    },
    {
      id: 3,
      name: 'Prof. Dr. Hatice Kaplan Can',
      email: 'hkaplan@hacettepe.edu.tr',
      title: t('faculty_board.professor_member'),
      image: 'https://avesis.hacettepe.edu.tr/user/image/6466',
    },
    {
      id: 4,
      name: 'Prof. Dr. Ali Aslan Dönmez',
      email: 'donmez@hacettepe.edu.tr',
      title: t('faculty_board.professor_member'),
      image: 'https://avesis.hacettepe.edu.tr/user/image/6298',
    },
    {
      id: 5,
      name: 'Doç. Dr. Bengi Özgün Öztürk',
      email: 'bengi04@hacettepe.edu.tr',
      title: t('faculty_board.associate_professor_member'),
      image: 'https://avesis.hacettepe.edu.tr/user/image/7496',
    },
    {
      id: 6,
      name: 'Doç. Dr. Özge Karadağ Ataş',
      email: 'ozgekaradag@hacettepe.edu.tr',
      title: t('faculty_board.associate_professor_member'),
      image: 'https://avesis.hacettepe.edu.tr/user/image/6271',
    },
    {
      id: 7,
      name: 'Dr. Öğr. Üyesi Başak Bulut Karageyik',
      email: 'basakbulut@hacettepe.edu.tr',
      title: t('faculty_board.assistant_professor_member'),
      image: 'https://avesis.hacettepe.edu.tr/user/image/8452',
    },
    {
      id: 8,
      name: 'Öğr. Gör. Dr. Güzin Emecen',
      email: 'guzin@hacettepe.edu.tr',
      title: t('faculty_board.lecturer_representative'),
      image: 'https://avesis.hacettepe.edu.tr/user/image/6001',
    },
    {
      id: 9,
      name: 'Gülnihal Doğruyol Aslan',
      email: 'nihala@hacettepe.edu.tr',
      title: t('faculty_board.faculty_secretary_rapporteur'),
      image: 'https://avesis.hacettepe.edu.tr/Content/images/user2.png',
    },
    {
      id: 10,
      name: 'Arş. Gör. Yavuz Alagöz',
      email: 'yavuzalagoz@hacettepe.edu.tr',
      title: t('faculty_board.research_assistant_representative'),
      image: 'https://avesis.hacettepe.edu.tr/user/image/100871',
    },
  ];

  return (
    <PageTemplate title={t('management_board.title')}>
      <div className="management-board-container">
        {boardMembers.map((member) => (
          <div key={member.id} className="member-card">
            <img src={member.image} alt={member.name} className="member-photo" />
            <h3 className="member-name">{member.name}</h3>
            <p className="member-title">{member.title}</p>
            <p className="member-email">{member.email}</p>
          </div>
        ))}
      </div>
    </PageTemplate>
  );
};

export default ManagementBoard; 